<template lang="html">
  <div class="add-article tier tier-three">
    <div class="tier-content">
      <Overlay width="small" :link="{name: 'articles'}">
        <Notification
          v-if="notification.active"
          :withinOverlay="true"
          :content="notification.content"
          :type="notification.type"
        />

        <add-article-form
          v-if="!articleCreated"
          v-model="siteArticle"
          :errors="errors"
          @submit="submitArticle"
          :websiteUrl="site.domain"
        >
        </add-article-form>
      </Overlay>
    </div>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'

import page from '@/mixins/page'
import notification from '@/mixins/notification'
import {readCompanySiteData} from '@/lib/sites'

import {
  createCompanySiteArticleData,
  updateCompanySiteArticleImage,
  updateCompanySiteArticleData
} from '@/lib/articles'

import AddArticleForm from '@/components/forms/AddArticleForm'
import Overlay from '@/components/Overlay'

export default {
  name: 'AddArticle',

  components: {
    AddArticleForm,
    Overlay
  },

  mixins: [page, notification],

  props: {
    siteId: String,
    companyId: String
  },

  data() {
    return {
      site: {},
      createdArticle: {},
      siteArticle: {},
      articleCreated: false,
      title: 'Add Article',
      errors: {}
    }
  },

  computed: {
    ...mapGetters(['sessionToken']),

    images() {
      return this.siteArticle.featured_image_versions
    },

    stringUpdateFunction() {
      const companyId = this.companyId
      const siteId = this.siteId
      const articleId = this.createdArticle.id

      return (article) => {
        return updateCompanySiteArticleData(
          companyId,
          siteId,
          articleId,
          article
        ).then(({data}) => {
          // TODO: duplicated below... prolly worth a tidy up

          // computed is currying callback function to be used by upload form
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.article = data

          this.triggerNotification('success', 'image', 'uploaded')

          this.$emit('updatePage')

          return data
        })
      }
    },

    fileUpdateFunction() {
      const companyId = this.companyId
      const siteId = this.siteId
      const token = this.sessionToken
      const articleId = this.createdArticle.id

      return (article) => {
        return updateCompanySiteArticleImage(
          companyId,
          siteId,
          articleId,
          article,
          token
        ).then(({data}) => {
          // computed is currying callback function to be used by upload form
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.article = data

          this.triggerNotification('success', 'image', 'uploaded')

          this.$emit('updatePage')

          return data
        })
      }
    }
  },

  methods: {
    getData() {
      readCompanySiteData(this.companyId, this.siteId).then(({data}) => {
        this.site = data
      })
    },

    submitArticle() {
      createCompanySiteArticleData(
        this.companyId,
        this.siteId,
        this.siteArticle
      )
        .then(({data}) => {
          this.triggerNotification('success', 'article', 'created')

          this.createdArticle = data

          window.setTimeout(() => {
            this.$router.push({
              name: 'article',
              params: {
                companyId: this.companyId,
                siteId: this.siteId,
                articleId: this.createdArticle.id
              }
            })
          }, this.closeDelay)
        })
        .catch(({response}) => {
          this.errors = response.errors
        })
    }
  },

  mounted() {
    this.getData()
  }
}
</script>

<style lang="sass">
.add-article
  .btn
    a
      color: #fff
</style>
